import React, { useState, useEffect } from 'react';

export default function useCitySearch({ stateUF = '' }) {
  const [cities, setCities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const getCities = async () => {
      if(!stateUF) {
        return;
      }

      setIsLoading(true);

      try  {
        const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${stateUF}/municipios?orderBy=nome`);
        const data = await response.json();

        if(!isMounted) {
          return;
        }

        setCities(data?.map(city => city?.nome));
      } catch(error) {
        console.log(error);
      } finally {
        if(!isMounted) {
          return;
        }

        setIsLoading(false);
      }
    }

    getCities();

    return () => { isMounted = false }
  }, [stateUF]);

  return {
    cities,
    isLoading
  }
}